import { Inline } from '@/design-system/inline/inline';
import { Stack } from '@/design-system/stack/stack';
import { cn } from '@/utils/cn';

const getStepStatus = (stepIndex: number, currentStepIndex: number): 'completed' | 'current' | 'upcoming' => {
  if (stepIndex < currentStepIndex) return 'completed';
  if (stepIndex === currentStepIndex) return 'current';
  return 'upcoming';
};

type VerticalStepperProps = {
  steps: { label: string }[];
  currentStepIndex: number;
};

export const VerticalStepper = ({ steps, currentStepIndex }: VerticalStepperProps) => {
  return (
    <nav>
      <Stack>
        {steps.map((step, index) => {
          const status = getStepStatus(index, currentStepIndex);
          return (
            <div key={step.label}>
              {index > 0 && (
                <div className="relative h-[30px] w-full pl-[3px]">
                  <div
                    className={cn('absolute h-full w-[2px]', {
                      'bg-black': status === 'completed' || status === 'current',
                      'bg-gray-300': status === 'upcoming',
                    })}
                  />
                </div>
              )}
              <Inline space={3} align="center">
                <span
                  className={cn('h-2 w-2 shrink-0 rounded-full', {
                    'bg-black': status === 'completed',
                    'bg-yellow-300': status === 'current',
                    'bg-gray-300': status === 'upcoming',
                  })}
                  aria-hidden="true"
                />
                <span
                  className={cn('text-sm font-normal', {
                    'text-black': status === 'completed' || status === 'current',
                    'text-gray-300': status === 'upcoming',
                  })}
                >
                  {step.label}
                </span>
              </Inline>
            </div>
          );
        })}
      </Stack>
    </nav>
  );
};
